import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";
import { PageHero, Reveal, SectionTag } from "../components/Reveal";

const Grupo = () => {
  const { t } = useLanguage();
  const p = t.group;

  return (
    <main data-testid="group-page">
      <PageHero chip={p.chip} title={p.title} sub={p.sub} testid="group-hero" />

      {/* OPS protagonista */}
      <section className="px-6 lg:px-12 py-20 border-b border-ops">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <Reveal className="lg:col-span-5">
            <div className="p-12 rounded-2xl border border-ops bg-ops-surface flex items-center justify-center">
              <span className="bg-white rounded-xl px-8 py-6 inline-flex items-center">
                <img src={IMAGES.opsLogo} alt="Open Port Services" data-testid="group-ops-logo" className="h-24 w-auto" />
              </span>
            </div>
          </Reveal>
          <div className="lg:col-span-7 space-y-5">
            <SectionTag>{p.opsTag}</SectionTag>
            <Reveal>
              <h2 className="font-display text-3xl sm:text-5xl font-extrabold uppercase text-white leading-tight">{p.opsTitle}</h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-base text-ops-muted leading-relaxed max-w-xl">{p.opsText}</p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* EVK discreta */}
      <section className="px-6 lg:px-12 py-16">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div
              data-testid="group-evk-block"
              className="flex flex-col md:flex-row items-center gap-8 p-8 rounded-xl border border-ops bg-ops-panel"
            >
              <span className="bg-white/90 rounded-lg px-4 py-3 inline-flex items-center shrink-0 opacity-80">
                <img src={IMAGES.evkLogo} alt="EVK Agency" data-testid="group-evk-logo" className="h-12 w-auto" />
              </span>
              <div className="space-y-2 text-center md:text-left">
                <span className="mono-tag text-[10px] text-ops-light uppercase tracking-widest block">{p.evkTag}</span>
                <h3 className="font-display text-lg font-bold text-white">{p.evkTitle}</h3>
                <p className="text-xs text-ops-muted leading-relaxed max-w-2xl">{p.evkText}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Grupo;
